import { DateTime } from 'luxon';

export class LockDayEditor {
    date: DateTime;
    userId: number;
    history: History;
}

export class LockDayFilters {
    date: DateTime;
    userId: number;
    history: History;
}

export class LockedDaySummary {
    locked: boolean;
    lockedByYou: boolean;
    lockedByDate: boolean;
    lockable: boolean;
    latestDate: DateTime;
}

export class LogChange {
    change: string;
    timeOfChange: DateTime;
}

export class History {
    changes: LogChange[] = [];
    name: string;
}




// WEBPACK FOOTER //
// ./src/models/lock-day.models.ts